import { render, staticRenderFns } from "./ContainerRequestsOrg.vue?vue&type=template&id=6ad13174&"
import script from "./ContainerRequestsOrg.vue?vue&type=script&lang=js&"
export * from "./ContainerRequestsOrg.vue?vue&type=script&lang=js&"
import style0 from "./ContainerRequestsOrg.vue?vue&type=style&index=0&id=6ad13174&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports